import { SgDatePicker } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import { OptionFormGroup } from '@/App/tiles/Option/fields/OptionFormGroup.tsx';
import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { selectOptionHedge } from '@/store/option/selectors/optionSelectors.ts';
import type { LegId } from '@/store/option/state.ts';

type MidPriceProps = {
  tileId: string;
};

export function HedgeDate({ tileId }: MidPriceProps) {
  const legId: LegId = `${tileId}/0`;
  const { hedgeDate, hedgeType } = useOptionSelector((tile) => {
    const hedge = selectOptionHedge(tile, legId);
    return {
      hedgeDate: hedge?.maturityDate,
      hedgeType: tile.properties.hedgeType,
    };
  });

  if (hedgeType === 'Live') {
    return null;
  }

  return (
    <OptionFormGroup label={<FormattedMessage id="option.fields.hedgeDate" values={{ hedgeType }} />}>
      {hedgeDate && (
        <SgDatePicker size="sm" isReadonly values={[hedgeDate]} selectionType="single" onChange={() => {}} />
      )}
    </OptionFormGroup>
  );
}
